// Interface

import util from '@/utils/classToObject'
import { IUserState } from './state'
import { AloDbUser } from '@/models/alodb/AloDbUser'

export class UserGetter {  
      
  public users(state:IUserState,getters:any) {
    return state.users
  }
  
  public usersById(state:IUserState) {
    return state.users.reduce(
      (acc, user) => {
        acc[user.USR_ID!] = user
        return acc
      },
      {} as { [id: number]: AloDbUser }
    )
  } 

  public modifiedAdmUser(state:IUserState,getters:any) {
    return state.modifiedAdmUser
  }

  public modifiedAdmUserRolesMapping(state:IUserState,getters:any) {
    return state.modifiedAdmUserRolesMapping
  }

  public originalAdmUser(state:IUserState,getters:any) {
    return state.originalAdmUser
  }

  public userLoading(state:IUserState,getters:any) {
    return state.userLoading
  }

  public roleMappingLoading(state:IUserState,getters:any) {
    return state.roleMappingLoading
  }
  
  public roleMappingLoadingByType(state:IUserState,getters:any) {
    return (type:string) => {        
        return state.roleMappingLoadingByType[type]
    } 
  }  

  public userStatus(state:IUserState) {     
    return state.status
  }

  public adminUserFilter(state:IUserState) {     
    return state.adminFilter
  }

}

export default util.classToObject(UserGetter)